import angular from 'angular';

module.exports = angular.module('market.components.od-listing-status', [])
.directive('odListingStatus', function() {
  return {
    restrict: 'EA',
    scope: {
      listing: '=',
      showActive: '='
    },
    template: require('./od-listing-status.jade')(),
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/components/od-listing-status.js
 **/